// =============================================================================
// features/sales/campaigns/detail/components/SettingsIdentityFieldset.tsx —
// Campos "núcleo" (nome, descrição, estratégia, responsável) da aba
// Configuração — extraído de SettingsTab.tsx para manter o orquestrador
// abaixo de 200 linhas (norma anti-padrão do DS).
// =============================================================================

import type { AssignmentStrategy } from '@elemento/shared-schemas';
import * as React from 'react';

import { Input } from '../../../../../components/ui/Input';
import { Select } from '../../../../../components/ui/Select';
import { FormTextarea } from '../../../components/FormTextarea';
import type { SettingsFormValues } from '../useCampaignSettingsForm';

const STRATEGY_OPTIONS: { value: AssignmentStrategy; label: string }[] = [
  { value: 'shared_queue', label: 'Fila compartilhada' },
  { value: 'fixed_owner', label: 'Responsável fixo' },
  { value: 'round_robin', label: 'Distribuição balanceada' },
];

export interface SettingsIdentityFieldsetProps {
  values: SettingsFormValues;
  isFieldAllowed: (key: 'name' | 'description' | 'assignmentStrategy' | 'ownerUserId') => boolean;
  setField: <K extends keyof SettingsFormValues>(key: K, value: SettingsFormValues[K]) => void;
}

export function SettingsIdentityFieldset({
  values,
  isFieldAllowed,
  setField,
}: SettingsIdentityFieldsetProps): React.JSX.Element {
  return (
    <fieldset className="flex flex-col gap-4">
      <legend className="font-sans text-xs font-semibold uppercase tracking-wide text-ink-3 mb-1">
        Identificação
      </legend>
      <Input
        id="settings-name"
        label="Nome"
        value={values.name}
        disabled={!isFieldAllowed('name')}
        onChange={(e) => setField('name', e.target.value)}
      />
      <FormTextarea
        id="settings-description"
        label="Descrição"
        value={values.description}
        disabled={!isFieldAllowed('description')}
        onChange={(e) => setField('description', e.target.value)}
      />
      <Select
        id="settings-strategy"
        label="Estratégia de distribuição"
        options={STRATEGY_OPTIONS}
        value={values.assignmentStrategy}
        disabled={!isFieldAllowed('assignmentStrategy')}
        onChange={(e) => setField('assignmentStrategy', e.target.value as AssignmentStrategy)}
      />
      <Input
        id="settings-owner"
        label="Responsável (id do usuário)"
        value={values.ownerUserId}
        disabled={!isFieldAllowed('ownerUserId')}
        onChange={(e) => setField('ownerUserId', e.target.value)}
        hint="UUID de users.id — reatribuição de titularidade."
      />
    </fieldset>
  );
}
